import { render, staticRenderFns } from "./CurriculumMobileSticky.vue?vue&type=template&id=dbb94d4a"
import script from "./CurriculumMobileSticky.vue?vue&type=script&lang=js"
export * from "./CurriculumMobileSticky.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports